import { ReferenceError, document, parentNode, pushToArray } from "@acng/frontend-bounty";
import { createContextProvider } from "./global.js";
import { CTX_ALERT, CTX_OBSERVE, CTX_PROVIDE, CTX_REVOKE, CTX_SUBSCRIBE_CLASSNAME, CTX_SUBSCRIBE_TAGNAME, CTX_UNOBSERVE, CTX_VALUE, } from "../../minify.js";
/**
 * @template T
 * @typedef {(Element | Document) & {[key: symbol]: import("./interface").Context<T>}} LocalProviderElement
 */
/**
 * @template T
 * @returns {import("./interface").Context<T>}
 */
export function createContext() {
    const contextSymbol = Symbol();
    /**
     * @type {Array<string>}
     */
    const consumerCollections = [];
    /**
     * @param {ParentNode | null} consumer
     */
    const get = (consumer) => {
        for (let p = consumer; p; p = parentNode(p)) {
            let found = /** @type {LocalProviderElement<T>} */ (p)[contextSymbol];
            if (found) {
                return found;
            }
        }
        DEBUG: console.error(`discovery/context {debugSymbol} missing context`, { consumer });
        throw ReferenceError();
    };
    return {
        [CTX_PROVIDE]: (providerElement, value) => {
            const localContextProvider = /** @type {LocalProviderElement<T>} */ (providerElement ?? document)[contextSymbol];
            if (!localContextProvider) {
                /** @type {LocalProviderElement<T>} */ (providerElement ?? document)[contextSymbol] = createContextProvider(value, consumerCollections);
            }
            else {
                localContextProvider[CTX_PROVIDE](providerElement, value);
            }
            return value;
        },
        [CTX_REVOKE]: (providerElement) => delete ( /** @type {LocalProviderElement<T>} */(providerElement)[contextSymbol]),
        [CTX_VALUE]: (consumer) => get(consumer)[CTX_VALUE](consumer),
        [CTX_SUBSCRIBE_TAGNAME]: (tagName) => pushToArray(consumerCollections, tagName),
        [CTX_SUBSCRIBE_CLASSNAME]: (classNames) => pushToArray(consumerCollections, classNames.split(' ').map(s => `.${s}`).join('')),
        [CTX_OBSERVE]: (consumer, handler) => get(consumer)[CTX_OBSERVE](consumer, handler),
        [CTX_ALERT]: (consumer, handler) => get(consumer)[CTX_ALERT](consumer, handler),
        [CTX_UNOBSERVE]: (consumer) => get(consumer).unobserve(consumer),
    };
}
